export enum RouteNames {
  login = 'login',
  verifyEmail = 'verifyEmail',
  requestPasswordReset = 'requestPasswordReset',
  resetPassword = 'resetPassword',
  dashboard = 'dashboard',
  pictures = 'pictures',
  guests = 'guests',
  guestsTable = 'guestsTable',
  admin = 'admin',
  download = 'download',
  calculators = 'calculators',
  calculatorsPage = 'calculatorsPage',
  settings = 'settings',
}
